import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./ResultCard.scss";
import star from "assets/icons/search/star.svg";
import bathroom from "assets/icons/search/bathroom.svg";
import bed from "assets/icons/search/bed.svg";
import guest from "assets/icons/search/guests.svg";
import special from "assets/images/result/special.svg";
import viewallIcon from "assets/icons/search/arrow-search.svg";
import Slider from "react-slick";
import { Amenities } from "./components/Amenities/Amenities";
import { Services } from "./components/Services/Services";
import SearchSkeleton from "features/search-property/components/SearchSkeleton/SearchSkeleton";
import { Attractions } from "./components/Attractions/Attractions";
import placeholder from "assets/images/result/placeholder.svg";
import { useHistory } from "react-router-dom";
import Wishlist from "./components/WishList/Wishlist";
import { setCurrentRoom, updateDates } from "features/stay-details/stay-details.slice";
import { useAppDispatch } from "store/store";

interface ISearchResult {
  room_category: {
    id: string;
    name: string;
    bedrooms: string;
    bathrooms: string;
    max_occupants: string;
    slug: string;
    created: string;
    external_id: number;
    is_featured: boolean;
    nice_name: string;
    sub_title: string;
  };
  name: string;
  rating: {
    score: number;
    count: number
  }
  price: {
    member: {
      daily_rate: number,
      offer: any
    },
    'non-member': {
      daily_rate: number,
      offer: any
    }
  };
  amenities: [];
  property: {
    services: [];
    attractions: [];
    id: string;
  }
  images: [];
  index: number;
  id: string;
  filter: {
    filter_id: string
  };
  offers: any;
  wishlist_status: boolean;
}
const ResultCard: React.FC<ISearchResult> = (props) => {
  const {t} = useTranslation();
  const filterid: any = props.filter.filter_id || 0;
  const deviceReady = () => {
    let devicesetting = {};
    if (window.innerWidth < 768) {
      devicesetting = {
        className: "search-carousel",
        infinite: true,
        slidesToShow: 1,
        speed: 500,
      };
    } else if (window.innerWidth > 768 && window.innerWidth < 1110) {
      devicesetting = {
        className: "center",
        infinite: true,
        centerPadding: "50px",
        slidesToShow: props.images?.length === 0 ? 1 : 2,
        speed: 500,
      };
    }
    return devicesetting;
  };
  const [dimensions, setDimensions] = useState(deviceReady());
  useEffect(() => {
    function handleResize() {
      setDimensions(deviceReady());
    }
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  });
  const settings = {
    ...dimensions,
    prevArrow: (
      <div>
        <div className="slide-arrow">
          <img src={viewallIcon} alt="view all"></img>
        </div>
      </div>
    ),
    nextArrow: (
      <div>
        <div className="slide-arrow">
          <img
            src={viewallIcon}
            alt="view all-right"
            className="view-all-right"
          ></img>
        </div>
      </div>
    ),
  };
  const history = useHistory();
  const dispatch = useAppDispatch();
  const handleRedirection = (e: any, data: any) => {
    e.preventDefault();
    const fetchPriceDetails = () => new Promise<void>((resolve, reject) => {
      dispatch(setCurrentRoom(data.room_category.id));
      resolve();
    });
    fetchPriceDetails();
    dispatch(updateDates(false));
    history.push(`/stay-details/${data.room_category.slug}`);
  }

  return (
    props.images ?
      <div className="columns result-card relative"
        key={props.index + props.property.id}
      >
        <div className=" padding-none relative slide-wrap">
          {props.images.length !== 0 && (
            <Slider {...settings}>
              {props.images.map((item: any, index) => (
                <div key={index}>
                  <div
                    style={{ backgroundImage: `url(${item.url})`, cursor: "pointer" }}
                    className="result-image"
                    onClick={(e) => handleRedirection(e, props)}
                  ></div>
                </div>
              ))}
            </Slider>
          )}

          {props.images.length === 0 && (
            <Slider {...settings}>
              <div
                className="empty-result-holder"
                onClick={(e) => handleRedirection(e, props)}
                style={{ cursor: "pointer" }}
              >
                <img src={placeholder} alt="placeholder-img"></img>
              </div>
            </Slider>
          )}
          {localStorage.getItem(`${window.location.host}AUTH_DETAILS`) && <Wishlist {...props}></Wishlist>}
        </div>
        <div className="column result-card-content relative">
          <a
            href={`/stay-details/${props.room_category.slug}`}
            className="result-card-title highlight-onhover"
            style={{ cursor: "pointer" }}
            onClick={(e) => handleRedirection(e, props)}
          ><span className="property-name">{props?.room_category?.nice_name || props?.room_category?.name}</span></a>

          <div className="special-container"
            style={{ cursor: "pointer" }}
            onClick={(e) => handleRedirection(e, props)}
          >
            <div
              style={{ backgroundImage: `url(${special})` }}
              className="special-price"
            >
              <div className="special-title white">{t('resultCard.forMem')}</div>
              <div className={`special-amnt ${props.price.member.offer[Object.keys(props.price.member.offer)[filterid] as string] ? 'appliedoffer' : ''}`}>
                AED {props?.price?.member?.daily_rate}
                <span style={{ fontWeight: 400 }}>/{t('payment.night')}</span>
              </div>
            </div>
            <div>
            
              {props.price.member.offer[props.offers[0]?.id] && <div className="offer-price">
                {'AED ' + props.price.member.offer[props.offers[0]?.id]?.price}
                <span style={{ fontWeight: 400 }}>/{t('payment.night')}</span></div>}
            </div>
            <div>
              <div className="special-title black">{t('resultCard.nonMem')}</div>
              <div className="special-amnt black">
                AED {props?.price["non-member"].daily_rate}
                <span style={{ fontWeight: 400 }}>/{t('payment.night')}</span>
              </div>
            </div>
            <div className="featured-card-rating bottom-rating"
              style={{ cursor: "pointer" }}
              onClick={(e) => handleRedirection(e, props)}
            >
              {/* Hide rating if rating count is unavailable */}
              {props.rating.count ? <>
                <span
                  className={`rating-value ${!props.rating.score
                    ? "rating-value-red"
                    : (props.rating.score as number) < 2
                      ? "rating-value-red"
                      : (props.rating.score as number) > 3
                        ? "rating-value-green"
                        : "rating-value-yellow"
                    }`}
                >
                  {props.rating.score}
                  <img alt="alt filler" src={star}></img>
                </span>
                <span className="rating-users">{props.rating.count} {t('bookAStay.rated')}</span>
              </> : <span className="rating-users">{props.rating.count} {t('bookAStay.rated')}</span>}
            </div>
          </div>
          {props.property.attractions?.length > 0 &&
            <div className="amenities-wrap"><Attractions {...props} name={t("common.attr")}></Attractions></div>}
          {props.property.services?.length > 0 &&
            <div className="amenities-wrap"><Services {...props} name={t("common.services")}></Services></div>}
          <div>
              <div className={`${props.property.services?.length === 0 || props.property.attractions?.length === 0 ? 'amenities-wrap' : ''}`}>
              <Amenities {...props} name={t("common.amnty")}>
              </Amenities></div>
          </div>
          {(props.property.attractions?.length === 0 && props.property.services?.length === 0) ?
            <div className="filler-card"></div> 
            :(props.property.attractions?.length === 0 || props.property.services?.length === 0) ? <div className="s-filler-card"></div>: null}
          {(props.amenities?.length === 0 && (props.property.attractions?.length !== 0 && props.property.services?.length !== 0)) &&
            <div className="s-filler-card"></div>}
          <div className="featured-card-amenities"
            style={{ cursor: "pointer" }}
            onClick={(e) => handleRedirection(e, props)}
             >
            <div className="amenities-list">
              <img alt="alt filler" src={bed}></img>
              <span className="amenity-no">{props.room_category?.bedrooms}</span>
              <span className="amenity-name">{t("common.bedrooms")}</span>
            </div>
            <div className="amenities-list">
              <img alt="alt filler" src={bathroom}></img>
              <span className="amenity-no">{props.room_category?.bathrooms}</span>
              <span className="amenity-name">{t("common.bathrooms")}</span>
            </div>
            <div className="amenities-list">
              <img alt="alt filler" src={guest}></img>
              <span className="amenity-no">{props.room_category?.max_occupants}</span>
              <span className="amenity-name">{t("common.maxpersons")}</span>
            </div>
          </div>
        </div>
      </div >
      : <SearchSkeleton></SearchSkeleton>
  );
};

export default ResultCard;